module.exports = __webpack_public_path__ + "static/media/hr-board.178727b6.svg";